import {
    AfterContentInit,
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ContentChildren,
    inject,
    Input,
    QueryList
} from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { TabComponent } from '../tab';

@Component({
    selector: 'app-tabset',
    templateUrl: './tabset.component.html',
    styleUrls: ['./tabset.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class TabsetComponent implements AfterContentInit {
    @Input() public destroyOnHide: boolean;

    private readonly tabChanged: Subject<TabComponent | null> = new Subject();
    public tabChanged$: Observable<TabComponent | null> = this.tabChanged.asObservable();

    @ContentChildren(TabComponent) public tabs: QueryList<TabComponent>;

    private readonly changeDetectorRef = inject(ChangeDetectorRef);

    public ngAfterContentInit() {
        const activeTabs = this.tabs.filter((tab) => tab.active);

        if (!activeTabs.length) {
            this.selectTab(this.tabs.first);
        }
    }

    public selectTab(tab: TabComponent) {
        if (!tab.disabled) {
            this.tabs.forEach((tab) => (tab.active = false));
            tab.active = true;
            this.changeDetectorRef.markForCheck();

            this.tabChanged.next(tab);
        }
    }
}
